import NewCashAdvance from "./NewCashAdvance";

export default NewCashAdvance;
